import React from "react";
import { leaf } from "../../assets";
import { motion } from "framer-motion";

const Hours = () => {
  return (
    <motion.div
      id="hours"
      whileInView={{ opacity: [0, 1], y: [30, 0] }}
      transition={{ duration: 0.7 }}
    >
      

      <div className="mainContent">
        <div className="dateTime">
          <div>
            <img src={leaf} alt="" />
            <p>Saturday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />
            <p>Sunday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />

            <p>Monday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />

            <p>Thuesday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />

            <p>Wednesday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />

            <p>Thursday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
          <div>
            <img src={leaf} alt="" />

            <p>Friday</p>
            <small>10.00 am - 08.00 pm</small>
          </div>
        </div>
        <div className="lineBall">
          <div className="balls">
            <div className="ball"></div>
            <div className="ball"></div>
            <div className="ball"></div>
            <div className="ball"></div>
            <div className="ball"></div>
            <div className="ball"></div>
            <div className="ball"></div>
          </div>
          <div className="line"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default Hours;
